var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import { useIsMobile } from '../../../../hooks';
import { fallbackImage } from '../../../../images';
var useGetIsMobile = function () { return useIsMobile().isMobile; };
export var TileIcon = function (_a) {
    var iconUrl = _a.iconUrl, title = _a.title;
    var altText = 'rewards icon';
    if (title === null || title === void 0 ? void 0 : title.includes('Pro Xtra Dollars'))
        altText = 'pro xtra dollars';
    else if (title === null || title === void 0 ? void 0 : title.includes('Rental'))
        altText = 'tool rental';
    else if (title === null || title === void 0 ? void 0 : title.includes('Drink'))
        altText = 'free drink';
    else if (title === null || title === void 0 ? void 0 : title.includes('Snack'))
        altText = 'free snack';
    else if (title === null || title === void 0 ? void 0 : title.toLowerCase().includes('off'))
        altText = 'coupon';
    else if (title === null || title === void 0 ? void 0 : title.includes('New'))
        altText = 'new unlocked perk';
    return (React.createElement("div", { className: "icon_container sui-max-w-[48px] sui-max-h-[48px] sui-h-12 sui-w-12 sui-flex sui-justify-center sui-items-center" },
        React.createElement("span", { className: "sui-w-full sui-h-full sui-text-center" },
            React.createElement("img", { src: "".concat(iconUrl), width: "48px", height: "48px", alt: altText, onError: fallbackImage }))));
};
var TileTitle = function (props) {
    var title = props.title;
    var Text = function () { return (React.createElement("div", { className: "" },
        React.createElement(Typography, { weight: "bold", component: "span" }, title))); };
    return (React.createElement("div", { className: "bolded_title sui-flex sui-gap-2" },
        React.createElement(Text, null)));
};
var TileSubtitle = function (props) {
    var subtitle = props.subtitle;
    return (React.createElement("div", { className: "grey_subtitle sui-pt-3" },
        React.createElement(Typography, null,
            React.createElement(React.Fragment, null, subtitle))));
};
var TileArrow = function (props) {
    var isMobile = props.isMobile;
    return (React.createElement("div", { className: "orange_arrow sui-text-brand sui-flex sui-flex-col sui-justify-center" },
        React.createElement(ArrowForward, { size: !isMobile ? 'regular' : 'small' })));
};
var urlRedirect = function (href) {
    if (href)
        window.location.href = href;
};
var TileContainer = function (props) {
    var children = props.children, hideBorder = props.hideBorder, href = props.href, isFirstTile = props.isFirstTile, containerCallback = props.containerCallback, isMobile = props.isMobile, type = props.type;
    var borderClass = hideBorder
        ? ''
        : 'sui-border-1 sui-border-solid sui-border-primary sui-rounded-base sui-mb-4';
    var suiWorkaroundDTW = useGetIsMobile() ? 'sui-px-4' : ''; // TODO: Fix SUI issue; should just be sui-px-4 sm:sui-px-0
    var paddingClass = "".concat(isMobile ? 'sui-py-4' : 'sui-py-5', " ").concat(isFirstTile ? 'sm:sui-pt-0 sm:sui-pb-4' : '');
    var containerClass = "".concat(type, " ").concat(suiWorkaroundDTW, " ").concat(paddingClass, " ").concat(borderClass, " sui-cursor-pointer sui-w-full sui-text-left sui-block");
    return (React.createElement("button", { type: "button", "data-testid": "rewards-tile", className: containerClass, onClick: href ? function () { return urlRedirect(href); } : containerCallback }, children));
};
export var RewardsTileMW = function (props) {
    var title = props.title, subtitle = props.subtitle, children = props.children, iconUrl = props.iconUrl, hideBorder = props.hideBorder, containerCallback = props.containerCallback, href = props.href, isFirstTile = props.isFirstTile, isMobile = props.isMobile, type = props.type;
    return (React.createElement(TileContainer, { containerCallback: containerCallback, hideBorder: hideBorder, href: href, isFirstTile: isFirstTile, isMobile: isMobile, type: type },
        React.createElement("div", { className: "above_content_container sui-flex sui-justify-between sui-gap-4" },
            React.createElement("div", { className: "icon_and_text_container sui-flex sui-gap-6 sui-w-full" },
                !!iconUrl && React.createElement(TileIcon, { iconUrl: iconUrl, title: title }),
                React.createElement("div", { className: "text_container sui-w-full" },
                    !!title && React.createElement(TileTitle, { title: title }),
                    !!subtitle && React.createElement(TileSubtitle, { subtitle: subtitle }),
                    !!children && React.createElement("div", null, children))),
            React.createElement(TileArrow, { isMobile: isMobile }))));
};
export var RewardsTileDTW = function (props) { return (React.createElement(RewardsTileMW, __assign({}, __assign(__assign({}, props), { hideBorder: true })))); };
